import {useState, useEffect, useCallback} from "react";
import {VacationBanner} from "../Views/VacationBanner";
import {Footer} from "../Views/Footer";
import {Navbar} from "../Views/Navbar";
import {Hero} from "../Views/Hero";
import {Team} from "../Views/Team";
import {Services} from "../Views/Services";
import {MapAndContact} from "../Views/MapAndContact";
import {API_URL} from "../../config";
import {OpeningHoursBanner} from "../../utility/OpeningHoursBanner";

export default function App() {
    const [scrolled, setScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState("");
    const [bannerData, setBannerData] = useState(null);
    const [bannerDismissed, setBannerDismissed] = useState(false);


    useEffect(() => {
        fetch(API_URL)
            .then((r) => r.json())
            .then((json) => setBannerData(json))
            .catch(() => {
            });
    }, []);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 10);
        window.addEventListener("scroll", onScroll, {passive: true});
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        const sections = ["leistungen", "team", "kontakt"];
        const observers = sections.map(id => {
            const el = document.getElementById(id);
            if (!el) return null;
            const obs = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) setActiveSection(id);
                },
                {rootMargin: "-30% 0px -60% 0px"}
            );
            obs.observe(el);
            return obs;
        });
        return () => observers.forEach(obs => obs?.disconnect());
    }, []);

    const handleBannerClose = useCallback(() => {
        setBannerDismissed(true);
    }, []);

    return (
        <>
            <Navbar scrolled={scrolled} activeSection={activeSection}/>
            <OpeningHoursBanner/>
            <VacationBanner bannerData={bannerData} dismissed={bannerDismissed} onClose={handleBannerClose}/>
            <Hero/>
            <Team/>
            <Services/>
            <MapAndContact/>
            <Footer/>
        </>
    );
}